import React from 'react';
import Container from '@mui/material/Container';
import * as S from '../styles';

export const Sidebar: React.FC<React.PropsWithChildren<{ sidebar }>> = ({ children, sidebar }) => (
  <Container disableGutters>
    <S.Grid
      container
      columnSpacing={12.5}
      direction={{
        sm: 'column-reverse',
        md: 'row',
      }}
      justifyContent="space-between"
    >
      <S.ContentGrid item sm={12} md={8}>
        {children}
      </S.ContentGrid>

      <S.Grid item sm={12} md={4}>
        {sidebar}
      </S.Grid>
    </S.Grid>
  </Container>
);
